import { ExtendedGfhAccount } from "@core/models/extended-gfh-account.model";
import { PendingIban } from "@core/models/pending-iban.model";
import { PendingNav } from "@core/models/pending-nav.model";
import { ProductVersions } from "@core/models/product-versions.model";
import { TPagination } from "@custom-types/sorting";
import { DashboardState } from "@features/dashboard/store/dashboard.reducer";
import { createFeatureSelector, createSelector } from "@ngrx/store";

const getDashboardFormState =
  createFeatureSelector<DashboardState>("dashboard");

export const SELECT_DASHBOARD_LOADING_STATUS = createSelector(
  getDashboardFormState,
  (state: DashboardState): boolean => state.loading
);

export const SELECT_PENDING_NAV_LIST = createSelector(
  getDashboardFormState,
  (state: DashboardState): Array<PendingNav> => state.pendingNavList
);

export const SELECT_PRODUCT_VERSION_CHANGED_LIST = createSelector(
  getDashboardFormState,
  (state: DashboardState): Array<ExtendedGfhAccount> => state.productVersionList
);

export const SELECT_SELF_APPROVAL_LIST = createSelector(
  getDashboardFormState,
  (state: DashboardState): Array<PendingIban> => state.selfApprovalList
);

export const SELECT_SELF_APPROVAL_LOADING_STATUS = createSelector(
  getDashboardFormState,
  (state: DashboardState): boolean => state.selfApprovalLoading
);

export const SELECT_APPROVAL_LIST = createSelector(
  getDashboardFormState,
  (state: DashboardState): Array<PendingIban> => state.approvalList
);

export const SELECT_APPROVAL_LOADING_STATUS = createSelector(
  getDashboardFormState,
  (state: DashboardState): boolean => state.approvalLoading
);

export const SELECT_LAST_SEVEN_DAYS_APPROVED_LIST = createSelector(
  getDashboardFormState,
  (state: DashboardState): Array<PendingIban> => state.lastSevenDaysList
);

export const SELECT_LAST_SEVEN_DAYS_LOADING_STATUS = createSelector(
  getDashboardFormState,
  (state: DashboardState): boolean => state.lastSevenDaysLoading
);

export const SELECT_PRODUCT_VERSIONS = createSelector(
  getDashboardFormState,
  (state: DashboardState): ProductVersions => state.productVersions
);

export const SELECT_PRODUCT_VERSIONS_LENGTH = createSelector(
  getDashboardFormState,
  (state: DashboardState): number => state.productVersionLength
);

export const SELECT_PRODUCT_VERSIONS_PAGINATION = createSelector(
  getDashboardFormState,
  (state: DashboardState): Partial<TPagination> | undefined =>
    state.productVersionPagination
);
